// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"49a2aef9","167":"008cf873","347":"09334a17","422":"0c75a3f7","454":"98374801","658":"0c6b1087","933":"a027a94e"}[chunkId] + ".chunk.js";
};